export default "__VITE_ASSET__cgYG7WUi__"